/** Entry point for a user's public profile. */

import { LabelPopup } from '../../common/label-detail/LabelPopup.js';
import { viewerClassFor } from '../../common/pano-viewer/viewerClassFor.js';
import { DashboardBadges } from '../../user-dashboard/DashboardBadges.js';
import { loadContributionMap } from '../../user-dashboard/contributionMap.js';
import '../../../css/components/map-frame.css';

const data = document.getElementById('page-entry').dataset;

// Deferred handle the contribution map's click adapter awaits; resolved (popup or null) once init finishes.
let labelPopupReadyResolve;
window.udLabelPopupReady = new Promise((resolve) => {
  labelPopupReadyResolve = resolve;
});

// Another mapper's streets and labels, from the public, username-keyed, public_profile-gated endpoints. Map labels
// open the shared label-detail popup, same as the owner's dashboard and LabelMap.
loadContributionMap({
  mapId: 'public-profile-choropleth',
  mapboxApiKey: data.mapboxApiKey,
  streetsURL: data.streetsUrl,
  labelsURL: data.labelsUrl,
  wireLabelPopup: true,
});

window.appManager.ready(async () => {
  const badges = document.getElementById('ud-badges');
  if (badges) {
    try {
      new DashboardBadges(badges).render();
    } catch (e) {
      console.error('Badge render failed', e);
    }
  }

  let labelPopup = null;
  try {
    const src = data.imagerySource;
    const viewerType = viewerClassFor(src);
    // The view sends a username only for a real account; anonymous sessions have autogenerated ones.
    labelPopup = await LabelPopup(false, viewerType, data.imageryAccessToken, data.username || null,
      { showLabelMapLink: true, showExploreHereLink: true });
  } catch (e) {
    console.error('Label popup init failed; map labels will not be clickable', e);
  }
  labelPopupReadyResolve(labelPopup);
});
